import { render, staticRenderFns } from "./CreatorDetail.vue?vue&type=template&id=a4e2a9e0&scoped=true"
import script from "./CreatorDetail.vue?vue&type=script&lang=js"
export * from "./CreatorDetail.vue?vue&type=script&lang=js"
import style0 from "./CreatorDetail.vue?vue&type=style&index=0&id=a4e2a9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e2a9e0",
  null
  
)

export default component.exports